var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImgBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.1875 9.13672C2.1875 9.25391 2.20703 9.37109 2.28516 9.46875L2.61719 9.97656C2.71484 10.1328 2.94922 10.25 3.14453 10.25H4.33594C4.53125 10.25 4.76562 10.1328 4.86328 9.97656L5.19531 9.46875C5.25391 9.39062 5.29297 9.23438 5.29297 9.13672L5.3125 8.375H2.1875V9.13672ZM3.75 0.25C1.75781 0.269531 0.3125 1.87109 0.3125 3.6875C0.3125 4.54688 0.625 5.32812 1.15234 5.93359C1.48438 6.30469 1.97266 7.08594 2.16797 7.73047C2.16797 7.73047 2.16797 7.73047 2.16797 7.75H5.3125C5.3125 7.73047 5.3125 7.73047 5.3125 7.73047C5.50781 7.08594 5.99609 6.30469 6.32812 5.93359C6.85547 5.34766 7.1875 4.56641 7.1875 3.6875C7.1875 1.79297 5.64453 0.269531 3.75 0.25ZM5.625 5.34766C5.3125 5.67969 4.94141 6.24609 4.66797 6.8125H2.8125C2.53906 6.24609 2.16797 5.67969 1.85547 5.34766C1.46484 4.87891 1.25 4.29297 1.25 3.6875C1.25 2.47656 2.1875 1.20703 3.73047 1.1875C5.11719 1.1875 6.25 2.32031 6.25 3.6875C6.25 4.29297 6.01562 4.87891 5.625 5.34766ZM3.4375 1.8125C2.55859 1.8125 1.875 2.51562 1.875 3.375C1.875 3.55078 2.01172 3.6875 2.1875 3.6875C2.34375 3.6875 2.5 3.55078 2.5 3.375C2.5 2.86719 2.91016 2.4375 3.4375 2.4375C3.59375 2.4375 3.75 2.30078 3.75 2.14453C3.75 1.96875 3.59375 1.8125 3.4375 1.8125Z",
    fill: "#36424E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgBulb);
export default __webpack_public_path__ + "static/media/img_bulb.47c2070cc74654cefe51653d15de1fc8.svg";
export { ForwardRef as ReactComponent };